// extracted by mini-css-extract-plugin
export default {"HeaderNav":"Navigations_HeaderNav__2waI4","MyName":"Navigations_MyName__RPTEg"};